import * as redux from 'redux';
import { LANGUAGE_SET } from './actions';

export interface ILanguageState {
    code: string;
}

function language(state: ILanguageState = { code: 'en' }, action: any = {}): ILanguageState {
    switch (action.type) {
        case LANGUAGE_SET:
            return {
                code: action.code,
            };
        default:
            return state;
    }
}

export const rootReducer: redux.Reducer<ILanguageState> = language;
